import { Spacings, TouchableOpacity } from "react-native-ui-lib";
import { Text, useThemeProvider } from "@towersystems/roam-common-native";

export interface SearchButtonProps {
  title: string;
  secondaryTitle?: string;
  onPress?: () => void;
}

export function SearchButton({
  title,
  secondaryTitle,
  onPress,
}: SearchButtonProps) {
  const { colors } = useThemeProvider();

  return (
    <TouchableOpacity
      onPress={onPress}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        backgroundColor: colors.surfaceProminent,
        paddingVertical: Spacings.s3 * 2,
        borderRadius: 8,
      }}
    >
      <Text fontWeight="bold" color="action" variant="heading2">
        {title}
      </Text>
      {!!secondaryTitle && <Text color="subdued">{secondaryTitle}</Text>}
    </TouchableOpacity>
  );
}
